var _defs, _rect, _rect2, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAptitudeCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 450,
    viewBox: "0 0 800 450",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a0f36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2B0057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#51158C"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 46,
    height: 46,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46 0 L 0 0 0 46",
    fill: "none",
    stroke: "#B163FF",
    strokeWidth: 1,
    opacity: 0.16
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: "50%",
    cy: "42%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B163FF",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B163FF",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#grid)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 190,
    r: 230,
    fill: "url(#glow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Georgia, 'Times New Roman', serif",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 140,
    fontSize: 72,
    opacity: 0.12
  }, "%"), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 110,
    fontSize: 58,
    opacity: 0.1
  }, "\xF7"), /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 360,
    fontSize: 80,
    opacity: 0.11
  }, "&#8730;"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 360,
    fontSize: 60,
    opacity: 0.1
  }, "&#960;"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 410,
    fontSize: 46,
    opacity: 0.09
  }, "&#8721;"), /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 410,
    fontSize: 46,
    opacity: 0.09
  }, "&#8734;"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -76,
    y: -96,
    width: 152,
    height: 192,
    rx: 18,
    fill: "rgba(255,255,255,0.10)",
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -44,
    y1: -54,
    x2: 44,
    y2: -54,
    stroke: "#ffffff",
    strokeWidth: 7,
    strokeLinecap: "round",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -32 -4 L -8 20 L 36 -28",
    stroke: "#ffffff",
    strokeWidth: 7,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: -44,
    y1: 50,
    x2: 44,
    y2: 50,
    stroke: "#ffffff",
    strokeWidth: 7,
    strokeLinecap: "round",
    opacity: 0.92
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAptitudeCover);
export default __webpack_public_path__ + "static/media/aptitude-cover.81ace1f4debc2f9bb0930c92a8f2b00d.svg";
export { ForwardRef as ReactComponent };